export enum AcceptanceLegalTermsResult {
    NOT_APPLICABLE,
    ACCEPTED,
    DECLINED,
    DISMISSED,
    INFORMATIONAL_VISIBLE
}